import * as React from 'react';
import cn from 'classnames/bind';
import classes from './index.module.scss.js';

// TODO: refactor this into an input wrapper which
// can be used to wrap individual inputs with labels and margins to fit into a form
const cx = cn.bind(classes);
class ElementContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: props.active,
        };
    }
    onFocus = () => {
        this.setState({ active: true });
    };
    onBlur = () => {
        this.setState({ active: false });
    };
    static getDerivedStateFromProps(props, state) {
        return {
            active: props.active !== undefined ? props.active : state.active,
        };
    }
    render() {
        const { disabled, children, icon, hasError } = this.props;
        const { active } = this.state;
        const withIcon = !!icon;
        return (React.createElement("div", { className: cx({
                container: true,
                active,
                disabled,
                withIcon,
                hasError,
            }), onFocus: this.onFocus, onBlur: this.onBlur }, icon ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: cx('icon') }, icon),
            React.createElement("div", { className: cx('elementWithIcon') }, children))) : (children)));
    }
}

export { ElementContainer as default };
//# sourceMappingURL=index.js.map
